import React from 'react';
import { ButtonView } from '../../buttons/button.view';

interface AdminHeaderButtonProps {
    onClick?: (e) => void;
    isLoading?: boolean;
    title: string;
    isDisabled?: boolean;
    style?: React.CSSProperties;
    className?: string;
    dataId?: string;
}

export const AdminHeaderButtonView = ({ onClick, isLoading, title, isDisabled, style, className, dataId }: AdminHeaderButtonProps) => (
    <ButtonView
        onClick={onClick}
        isLoading={isLoading}
        style={{
            ...style,
        }}
        disabled={isDisabled}
        className={className}
        dataId={dataId}
    >
        {title}
    </ButtonView>
);
